import { useQueryClient } from "@tanstack/react-query";
import { unpublishListing } from "../../api";
import { Listing } from "../../types";
import { AxiosResponse } from "axios";
import { useDomainMutation } from "@/modules/common/hooks/domain-mutation.hook";

export function useUnpublishListing() {
  const queryClient = useQueryClient();

  const mutationUnpublishListing = useDomainMutation<
    AxiosResponse<Listing>,
    { response?: { data?: { message?: string } } },
    string
  >({
    mutationFn: (uid: string) => unpublishListing(uid),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["listings"] });
    },
  });

  return mutationUnpublishListing;
}
